import axios from "axios";

export const attivaAccountApi = (user, token) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + "/api/sost/utente/" + user.id_utente + "/password/",
        user, {
            headers: {
                jwt: token
            }
        });
};
